import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { aiMessages } from '@atlaskit/editor-common/ai-messages';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import MagicWandIcon from '@atlaskit/icon/core/magic-wand';
import { RovoIcon } from '@atlaskit/logo';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';
import { improveWriting } from '../../ui/prebuilt/config-items/prompts/enhance/enhance';
import { createOpenAIModalCommand } from '../decoration/actions';
export var floatingToolbarAIButtonTestID = "ak-editor-ai-selection-toolbar-ai-button";
export var floatingToolbarAIDropdownTestIDPrefix = "ak-editor-ai-selection-toolbar-dropdown-";
export var getAIExperienceButton = function getAIExperienceButton(_ref) {
  var intl = _ref.intl,
    rangeBaseGenerate = _ref.rangeBaseGenerate,
    hideTitle = _ref.hideTitle,
    aiGlobalOptIn = _ref.aiGlobalOptIn,
    icon = _ref.icon,
    title = _ref.title,
    tooltip = _ref.tooltip,
    triggeredFor = _ref.triggeredFor,
    pulse = _ref.pulse,
    onMount = _ref.onMount,
    _onClick = _ref.onClick,
    disabled = _ref.disabled;
  var didMouseEnter = false;
  return _objectSpread(_objectSpread({
    type: 'button',
    pulse: pulse,
    showTitle: true,
    testId: floatingToolbarAIButtonTestID,
    icon: icon ? icon : AtlassianIntelligenceIcon
  }, !hideTitle && {
    title: intl.formatMessage(title !== null && title !== void 0 ? title : aiMessages.aiToolbarTitle)
  }), {}, {
    tooltipContent: intl.formatMessage(tooltip !== null && tooltip !== void 0 ? tooltip : sharedMessages.aiUniversalShortCallToAction),
    onMount: onMount,
    onMouseEnter: function onMouseEnter() {
      didMouseEnter = true;
      return false;
    },
    onClick: function onClick(state, dispatch, view) {
      var openAIModalCommand = createOpenAIModalCommand({
        state: state,
        configItem: rangeBaseGenerate,
        lastTriggeredFrom: 'floatingToolbar',
        // ED-18194 Added analytics for floating toolbar to determine
        // the % of users who click the button vs shift tab to it
        triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
        aiGlobalOptIn: aiGlobalOptIn,
        triggeredFor: triggeredFor
      });
      openAIModalCommand(state, dispatch);
      if (_onClick) {
        _onClick();
      }
      return false;
    },
    disabled: disabled
  });
};
export var getImproveWritingAIButton = function getImproveWritingAIButton(_ref2) {
  var intl = _ref2.intl,
    hideTitle = _ref2.hideTitle,
    aiGlobalOptIn = _ref2.aiGlobalOptIn,
    disabled = _ref2.disabled;
  var didMouseEnter = false;
  return _objectSpread(_objectSpread({
    type: 'button',
    showTitle: true,
    testId: "".concat(floatingToolbarAIButtonTestID, "-improve-writing"),
    icon:
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    fg('ai-smart-button-team-25') || editorExperiment('platform_editor_controls', 'variant1') ? MagicWandIcon : undefined
  }, !hideTitle && {
    title: intl.formatMessage(aiMessages.improveWritingToolbarIconTitle)
  }), {}, {
    tooltipContent: intl.formatMessage(aiMessages.improveWritingToolbarIconTooltip),
    onMouseEnter: function onMouseEnter() {
      didMouseEnter = true;
      return false;
    },
    onClick: function onClick(state, dispatch, view) {
      var openAIModalCommand = createOpenAIModalCommand({
        state: state,
        configItem: improveWriting,
        lastTriggeredFrom: 'floatingToolbar',
        triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
        aiGlobalOptIn: aiGlobalOptIn
      });
      openAIModalCommand(state, dispatch);
      return false;
    },
    disabled: disabled
  });
};
var mapSelectionToolbarDropdowns = function mapSelectionToolbarDropdowns(_ref3) {
  var selectionToolbarDropdowns = _ref3.selectionToolbarDropdowns,
    intl = _ref3.intl,
    aiGlobalOptIn = _ref3.aiGlobalOptIn,
    disabled = _ref3.disabled;
  if (!selectionToolbarDropdowns) {
    return [];
  }
  return selectionToolbarDropdowns.map(function (dropdownConfig) {
    var title = intl.formatMessage(dropdownConfig.label);
    if (dropdownConfig !== null && dropdownConfig !== void 0 && dropdownConfig.beta) {
      title = "".concat(title, " (").concat(intl.formatMessage(sharedMessages.betaLabel), ")");
    }
    return {
      type: 'dropdown',
      testId: floatingToolbarAIDropdownTestIDPrefix + dropdownConfig.id,
      title: title,
      disabled: disabled,
      options: dropdownConfig.options.map(function (option, index) {
        return {
          title: intl.formatMessage(option.label),
          testId: "ak-editor-ai-selection-toolbar-".concat(dropdownConfig.id, "-button-").concat(index),
          onClick: function onClick(state, dispatch, view) {
            var openAIModalCommand = createOpenAIModalCommand({
              state: state,
              configItem: option.configItem,
              lastTriggeredFrom: 'floatingToolbarDropdown',
              // ED-18194 Added analytics for floating toolbar to determine
              // the % of users who click the button vs shift tab to it
              // triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
              aiGlobalOptIn: aiGlobalOptIn
            });
            openAIModalCommand(state, dispatch);
            return false;
          }
        };
      })
    };
  });
};
export var getAIExperienceDropdowns = function getAIExperienceDropdowns(_ref4) {
  var intl = _ref4.intl,
    getSelectionToolbarDropdowns = _ref4.getSelectionToolbarDropdowns,
    aiGlobalOptIn = _ref4.aiGlobalOptIn,
    disabled = _ref4.disabled;
  var selectionToolbarDropdowns = getSelectionToolbarDropdowns === null || getSelectionToolbarDropdowns === void 0 ? void 0 : getSelectionToolbarDropdowns();
  var aiDropdowns = mapSelectionToolbarDropdowns({
    selectionToolbarDropdowns: selectionToolbarDropdowns,
    intl: intl,
    aiGlobalOptIn: aiGlobalOptIn,
    disabled: disabled
  });
  var separator = {
    type: 'separator'
  };
  var separatedAIDropdowns = aiDropdowns.reduce(function (acc, val) {
    return acc.concat(separator, val);
  }, []);
  return separatedAIDropdowns;
};
export var getPremiumAIButton = function getPremiumAIButton(_ref5) {
  var intl = _ref5.intl,
    rangeBaseGenerate = _ref5.rangeBaseGenerate,
    aiGlobalOptIn = _ref5.aiGlobalOptIn,
    triggeredFor = _ref5.triggeredFor,
    pulse = _ref5.pulse,
    onMount = _ref5.onMount,
    onClick = _ref5.onClick,
    disabled = _ref5.disabled;
  var Icon = function Icon() {
    return /*#__PURE__*/React.createElement(RovoIcon, {
      size: "small"
    });
  };
  return getAIExperienceButton({
    intl: intl,
    rangeBaseGenerate: rangeBaseGenerate,
    hideTitle: false,
    aiGlobalOptIn: aiGlobalOptIn,
    icon: Icon,
    title: aiMessages.askAIToolbarIconTitle,
    tooltip: aiMessages.askAIToolbarIconTooltip,
    triggeredFor: triggeredFor,
    pulse: pulse,
    onMount: onMount,
    onClick: onClick,
    disabled: disabled
  });
};